import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetAccountsRes } from '../models';

export interface ShellApi {
  getAccounts(isPolling: boolean): Observable<GetAccountsRes>;
}

export const SHELL_API = new InjectionToken<ShellApi>('SHELL_API');
